import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import {
  checklistTemplateEditorMutationKeys,
  RequestTypes,
} from '@core/react-query/features/templates/checklistTemplates'
import { projectsKeys } from '@core/react-query/features/projects'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useAssignProjectsToChecklistTemplate = (
  options?: UseMutationOptions<
    unknown,
    RequestErrorType,
    RequestTypes['assignProjectsToTemplate']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...checklistTemplateEditorMutationKeys.assignProjectsToTemplate,
    ...options,
    onSuccess: () => {
      queryClient.invalidateQueries(projectsKeys._def)
    },
  })
}
